export default __webpack_public_path__ + "static/media/brickfloor2.a9f1562d.png";